import axios from "axios";
import { translator } from "../../constants/actionTypes";
import {
  tenantManagementAPI as tenant,
  userManagementAPI as user,
} from "../../constants/apis/apiEndpoints";
import axiosInstance from "../../translator";
import { localStorageHelper } from "../../utils/storageHelper";

export const userManagementUploadApi = async (data) => {
  return axios
    .post(`${translator?.baseURL}${user?.csvUpload}`, data, {
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        tenant: localStorageHelper.get("tenantId"),
        accessToken: `Bearer ${localStorageHelper.get("accessToken")}`,
        Authorization: `${localStorageHelper.get("authToken")}`,
        role: localStorageHelper.get("role"),
        authtype: localStorageHelper.get("auth_type"),
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};

export const fetchUserListData = async (urlParams) => {
  return axiosInstance
    .get(`${user?.userEndpoint}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const deleteUserData = async (id) => {
  return axiosInstance
    .delete(`${user?.userEndpoint}/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const suspendUser = async (payload) => {
  return axiosInstance
    .put(
      `${user?.userEndpoint}/${user?.suspendUser}/${payload?.id}`,
      payload?.data
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const userManagementDefaultRolesApi = async () => {
  return axiosInstance
    .get(`${user.defaultRoles}`)
    .then((data) => {
      return data;
    })
    .catch((error) => {
      return error;
    });
};

export const userManagementAssignRolesApi = async () => {
  return axiosInstance
    .get(`${user.assignRoles}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const userManagementBusinessRolesApi = async (id) => {
  return axiosInstance
    .get(`${tenant.tenantEndpoint}${user.businessUnitRoles}/${id}`)
    .then((data) => {
      return data;
    })
    .catch((error) => {
      return error;
    });
};

export const userManagementCreateUserApi = async (data) => {
  return axiosInstance
    .post(`${user.userEndpoint}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const userManagementEditUserApi = async (data) => {
  return axiosInstance
    .get(`${user.userEndpoint}/${data}`, {
      id: data,
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const userManagementUpdateUserApi = async (data, id) => {
  return axiosInstance
    .put(`${user.userEndpoint}/${id}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const fetchUserInfo = async (id) => {
  return axiosInstance
    .get(`${user.userEndpoint}/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const activeUserDownloadApi = async (data) => {
  return axiosInstance
    .post(`${user.activeUsersDownload}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};
